import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Select from 'react-select';

const FilterTopBar = ({
  filter, callback,
}) => (
  <div>
    {filter && filter.sort((a, b) => a.sortingOrder - b.sortingOrder)?.map((data, key) => {
      const options = [];
      data.filterData.forEach((element) => {
        options.push({ label: element.shortValue, value: element.key });
      });
      return (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={key}>
          <Select
            options={options.sort((a, b) => a.label > b.label ? 1 : -1)}
            clearable={false}
            placeholder="Select Sales Channel"
            className="select_topbar-filter"
            isMulti
            onChange={val => callback(val, data.applyToColumn)}
          />
        </React.Fragment>
      );
    })}
  </div>
);

FilterTopBar.propTypes = {
  filter: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  callback: PropTypes.func.isRequired,
};

export default connect(state => ({
  rtl: state.rtl,
}))(FilterTopBar);